 
import React from 'react';
import { cn } from '@/lib/utils';

export const LOADER_MESSAGES = [
	'ENGAGING...',
	'IGNITING...',
	'STARTING...',
	'REVVING...',
	'FIRING UP...',
	'FUELING...',
	'ACTIVATING...',
	'LAUNCHING...',
	'CRANKING...',
	'CHARGING...',
	'INITIALIZING...',
	'UNLEASHING...',
	'SPARKING...',
	'MOBILIZING...',
	'ACCELERATING...',
	'CONNECTING...',
	'SUPERCHARGING...',
	'BOOSTING...',
	'ENERGIZING...',
] as const;

export const SIGNOUT_MESSAGES = [
	'POWERING DOWN...',
	'SIGNING OUT...',
	'DISCONNECTING...',
	'SHUTTING DOWN...',
	'GOODBYE...',
	'SEE YOU SOON...',
	'CLEARING SESSION...',
] as const;

interface LoaderProps {
	className?: string;
	message?: string;
}

export function Loader({ className, message }: LoaderProps) {
	return (
		<div className={cn('flex flex-col items-center gap-6', className)}>
			<div className='relative'>
				<div className='animate-spin rounded-full h-32 w-32 border-[12px] border-pink-500/30 border-b-pink-500'></div>
				<div className='absolute inset-0 flex items-center justify-center text-5xl'>
					🔥
				</div>
			</div>
			<div className='text-3xl font-medium text-pink-500/90 animate-pulse'>
				{message}
			</div>
		</div>
	);
}

interface PageLoaderProps {
	message?: string;
	type?: 'loading' | 'signout';
}

export function PageLoader({ message, type = 'loading' }: PageLoaderProps) {
	const defaultMessage = React.useMemo(() => {
		const messages =
			type === 'signout' ? SIGNOUT_MESSAGES : LOADER_MESSAGES;
		return messages[Math.floor(Math.random() * messages.length)];
	}, [type]);

	return (
		<div className='fixed inset-0 z-[100] flex items-center justify-center'>
			<div className='orb-container'>
				<div className='orb orb-1'></div>
				<div className='orb orb-2'></div>
				<div className='orb orb-3'></div>
				<div className='orb orb-4'></div>
				<div className='orb orb-5'></div>
			</div>
			<div className='absolute inset-0 bg-white/30 dark:bg-black/40' />
			<Loader message={message || defaultMessage} />
		</div>
	);
}
